function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClienteReceptoraPago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "company-Building-bank-Business-office") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 21,
    width: 14,
    height: 40,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 4,
    height: 4,
    transform: "translate(30 54) rotate(-180)",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 33,
    width: 4,
    height: 4,
    transform: "translate(30 70) rotate(-180)",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 41,
    width: 4,
    height: 4,
    transform: "translate(30 86) rotate(-180)",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 49,
    width: 4,
    height: 4,
    transform: "translate(30 102) rotate(-180)",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 56,
    width: 12,
    height: 2,
    style: {
      fill: "#0071bc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 21,
    width: 14,
    height: 40,
    transform: "translate(96 82) rotate(-180)",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 25,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 33,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 41,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 49,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 56,
    width: 12,
    height: 2,
    style: {
      fill: "#0071bc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 22,
    height: 48,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 60,
    width: 2,
    height: 2,
    style: {
      fill: "#0071bc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41 9.308 45 9 45 15 41 15 23 15 19 15 19 11 23 10.692 41 9.308",
    style: {
      fill: "#0071bc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 39,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 39,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 31,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 31,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 24,
    width: 2,
    height: 21,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 47,
    width: 2,
    height: 2,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 31,
    width: 2,
    height: 21,
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 46,
    width: 22,
    height: 2,
    style: {
      fill: "#0071bc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 12,
    r: 9,
    style: {
      fill: "#fed856"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,10V9.854a2.849,2.849,0,0,0-2-2.709V6H31V7.145a2.844,2.844,0,0,0-.422,5.262l1.949.974A.854.854,0,0,1,32.146,15h-.292A.855.855,0,0,1,31,14.146V14H29v.146a2.849,2.849,0,0,0,2,2.709V18h2V16.855a2.844,2.844,0,0,0,.422-5.262l-1.949-.974A.854.854,0,0,1,31.854,9h.292A.855.855,0,0,1,33,9.854V10Z",
    style: {
      fill: "#cd9829"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 23,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 4,
    height: 4,
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 51,
    width: 6,
    height: 10,
    style: {
      fill: "#56a8c6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 51,
    width: 6,
    height: 10,
    style: {
      fill: "#80c5d4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 55,
    width: 6,
    height: 2,
    style: {
      fill: "#dfd9d3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 60,
    width: 56,
    height: 2,
    style: {
      fill: "#0071bc"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClienteReceptoraPago);
export default __webpack_public_path__ + "static/media/cliente_receptora_pago.e21577c054c262430498864a7be8eac4.svg";
export { ForwardRef as ReactComponent };